import { useTranslation } from 'react-multi-lang/lib';
import React from 'react';

export default function TranslateText({ text = '' }) {
  const translations = useTranslation();
  return <>{translations(text)}</>;
}
